import { api } from '@/services'

const useAsyncClientAddress = async (clientId: string) => {
    let Response = null
    let Error = null

    const Controller = new AbortController()

    const MakeRequest = async () => {
        try {
            const resp = await api.get(
                `/Client/GetAddressByClient_id?id=${clientId}`,
                {
                    signal: Controller.signal
                }
            )
            if (resp.status === 200) {
                Response = resp.data
            } else {
                throw new Error(resp.statusText)
            }
        } catch (error) {
            Error = error.message
        }
    }

    await MakeRequest()

    Controller.abort()

    return [Response, Error]
}

export { useAsyncClientAddress }
